import { PathDetailMatDto } from '../../../dto/path/path-detail.dto';
import { PathPoint } from './path-point';

export class PathPointMat extends PathPoint {
  public bbx: string;
  public date: string;

  constructor(o: PathDetailMatDto) {
    super(o);
    this.bbx = o.bbx;
    this.date = o.date;
  }
}
